import { ConvexProvider, ConvexReactClient } from 'convex/react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import { StrictMode } from 'react';
import { AppRouter } from '@/AppRouter';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeProvider } from '@/components/ui+/ThemeProvider';
import { ConvexCachedQueries } from '@/components/wrappers/ConvexCachedQueries';
import { VersionGuard } from '@/components/wrappers/VersionGuard';

// Allow e2e tests to override the Convex URL via localStorage so multiple
// test workers can share a single Vite dev server.
const convexUrl =
  localStorage.getItem('ORTOMATE_CONVEX_URL') || (import.meta.env.VITE_CONVEX_URL as string);
const stage = import.meta.env.VITE_STAGE;

const convex = new ConvexReactClient(convexUrl, {
  unsavedChangesWarning: false,
  verbose: false,
});

// Set the page <title>, based on STAGE.
document.title = stage === 'production' ? 'Orto-Mate Pay' : `Orto-Mate Pay *${stage}`;

const rootElement = document.getElementById('app');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <ConvexProvider client={convex}>
        <VersionGuard>
          <ConvexCachedQueries>
            <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
              {/* https://www.radix-ui.com/primitives/docs/components/tooltip#api-reference */}
              <TooltipProvider delayDuration={150}>
                <AppRouter />
              </TooltipProvider>
            </ThemeProvider>
          </ConvexCachedQueries>
        </VersionGuard>
      </ConvexProvider>
    </StrictMode>,
  );
}
